import { getCurrentEnvironmentOrDefault } from '@shared/featureFlags/featureFlagContextFactory';
import { featureFlagConfig } from './featureFlags';

const NEW_DESIGN_THEME = 'new-design';

/**
 * Stamps the theme onto <html> before React mounts so the first paint is not
 * the bare :root blue palette (FOUC). DocumentTheme / useNewGuestLandingDocumentTheme
 * then keep the attribute in place for the life of the React tree.
 *
 * Reads the flag config directly rather than through FeatureFlagContext — there
 * is no context available this early (same pattern as router.tsx).
 */
export const applyDocumentTheme = () => {
  const environment = getCurrentEnvironmentOrDefault();

  if (featureFlagConfig[environment].newGuestLandingPage) {
    document.documentElement.setAttribute('data-theme', NEW_DESIGN_THEME);
  }
};
